import Pen from '../src/Pen';
export default Pen;
